import React, { useState } from "react";
import IREMaster from "./IRE/IREMaster.jsx";
import OthersSidebar from "./OthersSidebar";
import PDDMaster from "./PDD/PDDMaster.jsx";
import CrackReportMaster from "./Crack/CrackReportMaster.jsx";
import PointWiseInterchangeMaster from "./PointWiseInterchange/PointWiseInterchangeMaster.jsx";
import LonghaulMaster from "./LongHaul/LonghaulMaster.jsx";
import NKJYardExMaster from "./NKJYardEx/NKJYardExMaster.jsx";
import STAYardMaster from "./STAYardEx/STAYardMaster.jsx";
import STAYard from "./STAYardEx/STAYard.jsx";
const OtherMaster = () => {
  const [activePage, setActivePage] = useState("Pre Departure Detention (PDD)");
  return (
    <div className="row ">
      <div className="col-md-2">
        <div className="newUiBody">
          <OthersSidebar
            setActivePage={setActivePage}
            activePage={activePage}
          />
        </div>
      </div>
      <div
        className="col-md-10 border newUiBody"
        // style={{ maxHeight: "100vh", overflow: "auto" }}
      >
        <div className="">
          <div className="row">
            <h5 className="p-1 mb-1 bg-dark text-white">{activePage} </h5>
          </div>
          {activePage === "Pre Departure Detention (PDD)" && <PDDMaster />}
          {activePage === "Intensive Release Empty (IRE)" && <IREMaster />}
          {activePage === "Crack" && <CrackReportMaster />}
          {activePage === "Point Wise Interchange" && (
            <PointWiseInterchangeMaster />
          )}
          {activePage === "Long Haul" && <LonghaulMaster />}
          {activePage === "NKJ Yard Ex" && <NKJYardExMaster />}
          {activePage === "STA Yard" && <STAYard />}
        </div>
      </div>
    </div>
  );
};
export default OtherMaster;
